import { useTranslation } from "react-i18next";
import { Modal } from "@mui/material";
import { formatTimeRange, isEmptyList, isNullOrUndefined } from "../../utils";
import { ReactComponent as Cross } from "../../assets/cross.svg";

function StandDetailModal(props) {
  const { t } = useTranslation();
  const { timeChartInfo, onClose, airportTimezone } = props;

  function handleCloseModal() {
    onClose();
  }

  return (
    <div>
      <Modal
        open={!isNullOrUndefined(timeChartInfo)}
        onClose={handleCloseModal}
      >
        <div className="modal stand-detail-modal">
          {!isNullOrUndefined(timeChartInfo) && (
            <>
              <div>
                <div className="modal-header">
                  <h2>{`${t("stand_non_cap")}: ${timeChartInfo.name}`}</h2>
                  <div className="button-icon" onClick={handleCloseModal}>
                    <Cross />
                  </div>
                </div>
              </div>
              <div className="modal-body">
                <div className="modal-container">
                  <div className="stand-details-contents">
                    <div className="stand-details-header">
                      <div>
                        {t("turnarounds")} (
                        {!isEmptyList(timeChartInfo.itemBlocks)
                          ? timeChartInfo.itemBlocks.length
                          : 0}
                        )
                      </div>
                    </div>
                    <div className="stand-details-turnarounds">
                      {!isEmptyList(timeChartInfo.itemBlocks) &&
                        timeChartInfo.itemBlocks.map((itemBlock) => (
                          <StandDetailsRow
                            turnaroundInfo={itemBlock.barInfo}
                            airportTimezone={airportTimezone}
                            startTime={itemBlock.startTime}
                            endTime={itemBlock.endTime}
                            key={itemBlock.barInfo.uuid}
                          />
                        ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div></div>
                <div>
                  <button className="secondary" onClick={handleCloseModal}>
                    {t("close")}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
}

function StandDetailsRow(props) {
  const { turnaroundInfo, startTime, endTime, airportTimezone } = props;

  return (
    <div className="stand-details-turnaround">
      <div>{formatTimeRange(startTime, endTime, airportTimezone)}</div>
      <div>{turnaroundInfo.combinedFlightName}</div>
      <div>{turnaroundInfo.remarks}</div>
    </div>
  );
}

export default StandDetailModal;
